import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedRoutingModule } from './shared-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { InputTrimModule } from 'ng2-trim-directive';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  // MdCoreModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
} from '@angular/material';
import { FooterComponent } from '../shared/footer/footer.component';
import { HeaderComponent } from '../shared/header/header.component';
import { PopUpService } from './PopUpService';
import { RegisterationComponent } from './registeration/registeration.component';
import { LoginComponent } from './login/login.component';
// import { LoginService } from '../shared/login/login.service';
import { SharedService } from '../shared/shared.service';
import { OtpComponent } from './otp/otp.component';
import { LoginService } from './login/login.service';
import { EqualValidator } from './registeration/registerationDirective';
import { MyAccountComponent } from './my-account/my-account.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginWithOtpComponent } from './login-with-otp/login-with-otp.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { RecoverPasswordSuccComponent } from './recover-password-succ/recover-password-succ.component';
import { SuccessInfoComponent } from './success-info/success-info.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { LogoutPageComponent } from './logout-page/logout-page.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HasAnyAuthorityDirective } from './auth/has-any-authority.directive';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from '../../environments/environment';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from '../app-routing.module';
import { OnlyNumberDirective } from './only-number.directive';



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    // MdCoreModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    OnlyNumberDirective
  ],
  declarations: [LoginPageComponent, LogoutPageComponent, OnlyNumberDirective]
})
export class AngularMaterialModules { }

@NgModule({
  imports: [
    CommonModule,
    SharedRoutingModule,
    DeviceDetectorModule.forRoot(),
    FormsModule,
    InputTrimModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    }),
    RecaptchaModule
  ],
  declarations: [FooterComponent, HeaderComponent, RegisterationComponent, LoginComponent, OtpComponent, EqualValidator, MyAccountComponent, ForgotPasswordComponent, LoginWithOtpComponent, RecoverPasswordComponent, RecoverPasswordSuccComponent, SuccessInfoComponent, HasAnyAuthorityDirective],
  exports: [
    FooterComponent, HeaderComponent, RegisterationComponent, LoginComponent, OtpComponent, MyAccountComponent, ForgotPasswordComponent, LoginWithOtpComponent, RecoverPasswordComponent, RecoverPasswordSuccComponent, SuccessInfoComponent, HasAnyAuthorityDirective
  ],
  providers: [PopUpService, SharedService, LoginService]
})
export class SharedModule { }

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings
    }
  ]
})
export class CaptchaModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts